import React from 'react';
import { Col } from 'react-bootstrap';
import RelatedArticlesComponent from './RelatedArticlesComponent';
import { SHARE_LABEL } from './Constants';
import { ShareLabelRow, IconsRow } from './Styles/CalculatorStyles';

function SocialMediaComponent() {
    return (
        <Col sm={4}>
            <ShareLabelRow>{SHARE_LABEL}</ShareLabelRow>
            <IconsRow>
                <Col>
                    <img src={'/assets/facebook-icon.svg'} alt="Facebook" />
                </Col>
                <Col>
                    <img src={'/assets/linkedInlogo-blue.png'} alt="LinkedIn" />
                </Col>
                <Col>
                    <img src={'/assets/twitter-logo-blue.png'} alt="Twitter" />
                </Col>
                <Col>
                    <img src={'/assets/mail-icon.png'} alt="Mail" width="43" />
                </Col>
            </IconsRow>
            <RelatedArticlesComponent />
        </Col>
    );
}

export default SocialMediaComponent;
